import { render, staticRenderFns } from "./DeforestationComplianceReports.vue?vue&type=template&id=ec1da53e"
import script from "./DeforestationComplianceReports.vue?vue&type=script&lang=js"
export * from "./DeforestationComplianceReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports